import * as React from 'react';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

export const GeovapActionsBar = ({ onCloseItem, onSave }) => ({ state: { checkedItems } }) => {
  return (
    <React.Fragment>
      <div style={{ marginLeft: 5 }}>
        <Button label="Uložit označené" disabled={checkedItems.length === 0} onClick={() => onSave(checkedItems)} />
      </div>
      <div style={{ marginLeft: 5 }}>
        <Button label="Zavřít" onClick={onCloseItem} />
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/modules/dogs/DogsGridButtons.tsx